import 'utils/filter_form';
import 'utils/autofill_by_query_string';
import 'components/alphabetical_input';

import './index.scss';

(function ($) {
  const $filterForm = $('#js-administrative-levels-filter-form');

  $filterForm
    .autoFillByQueryString()
    .filterForm()
    .lazyReady();

  // $filterForm.on('submit', () => {
  //   $filterForm.trigger('filterFormToggle');
  //   return false;
  // });
})(jQuery);
